module.exports = __webpack_public_path__ + "dlssrvtline2/img/vi-slider-4.jpg?b28ff6f5";